<template>
  <button
    class="button"
    :class="`button--${type}`"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      type: { type: String, default: 'normal' }
    }
  }
</script>


<style scoped lang="scss">
  .button {
    color: #F03E33;
    background: linear-gradient(#fff, darken(#fff, 8%));
    padding: 1.0625rem 2.1875rem;
    font-size: 1.125rem;
    font-family: 'Inter';
    font-weight: 700;
    border-radius: 40px;
    box-shadow: 0 0 0 5px rgba(#fff, .2), 0px 30px 41px 1px rgba(0, 0, 0, 0.25);

    &:hover,
    &--reverse {
      background: linear-gradient(#F03E33, darken(#F03E33, 10%));
      color: #fff;
      text-shadow: 0 0 30px rgba(#fff, .8);
    }

    &--primary {
      background: linear-gradient(#FF8000, darken(#FF8000, 10));
      color: #fff;

      &:hover {
        background: linear-gradient(#FF8000, darken(#FF8000, 5));
      }
    }

    &--size-md {
      padding: 0.8125rem 2.1875rem;
    }
  }
</style>